import { render, staticRenderFns } from "./wholesale-history-chart.vue?vue&type=template&id=1b60ba2a&scoped=true"
import script from "./wholesale-history-chart.vue?vue&type=script&lang=js"
export * from "./wholesale-history-chart.vue?vue&type=script&lang=js"
import style0 from "./wholesale-history-chart.vue?vue&type=style&index=0&id=1b60ba2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b60ba2a",
  null
  
)

export default component.exports